import { generateConfidenceColors } from "./generateConfidenceColors";
const primary = "78.7% 0.119 304.769"; // mauve
const content = "87.9% 0.043 272.277"; // text

export const catppuccinMochaTheme = {
  name: "catppuccin",
  default: false,
  prefersDark: true,
  colorScheme: "dark",
  colors: {
    // Base colors
    "base-100": "24.3% 0.030 283.911", // base
    "base-200": "32.4% 0.032 281.978", // surface0
    "base-300": "40.2% 0.034 280.520", // surface1 (interpolated)
    "base-content": "87.9% 0.043 272.277", // text

    // Primary colors - Mauve
    "primary": "78.7% 0.119 304.769", // mauve
    "primary-content": "24.3% 0.030 283.911", // base

    // Secondary colors - Blue
    "secondary": "76.6% 0.111 259.885", // blue
    "secondary-content": "24.3% 0.030 283.911", // base

    // Accent colors - Sky
    "accent": "84.7% 0.083 210.255", // sky
    "accent-content": "24.3% 0.030 283.911", // base

    // Neutral colors
    "neutral": "32.4% 0.032 281.978", // surface0
    "neutral-content": "87.9% 0.043 272.277", // text

    // Semantic colors
    "info": "84.7% 0.083 210.255", // sky
    "info-content": "24.3% 0.030 283.911", // base
    "success": "85.8% 0.109 142.715", // green
    "success-content": "24.3% 0.030 283.911", // base
    "warning": "82.4% 0.101 52.629", // peach
    "warning-content": "24.3% 0.030 283.911", // base
    "error": "75.6% 0.130 2.764", // red
    "error-content": "87.9% 0.043 272.277", // text

    // Confidence levels
    ...generateConfidenceColors(primary, content, true)
  },
  dimensions: {
    "radius-selector": "0.5rem",
    "radius-field": "0.25rem",
    "radius-box": "0.5rem",
    "size-selector": "0.25rem",
    "size-field": "0.25rem",
    "border": "1px",
    "depth": "1",
    "noise": "0"
  }
};
